export const NETWORK_TYPE = {
    MAINNET: "MAINNET",
    TESTNET: "TESTNET"
}
const CHAIN_IDS = {
    [NETWORK_TYPE.MAINNET]: {
        ETHEREUM: 1,
        POLYGON: 137,
        BINANCE: 56,
    },
    [NETWORK_TYPE.TESTNET]: {
        ETHEREUM: 5,
        POLYGON: 80001,
        BINANCE: 97,
    },
};
export const NETWORK_CHAIN_IDS = CHAIN_IDS[process.env.NETWORK_TYPE === NETWORK_TYPE.MAINNET ? NETWORK_TYPE.MAINNET : NETWORK_TYPE.TESTNET];

const SUPPORTED_NETWORKS = {
    1: {
        chainId: 1,
        chainName: "Ethreum",
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        rpcUrls: ['https://mainnet.infura.io/v3/${INFURA_API_KEY}'],
        subgraphs: {
           "v-1" : "https://api.thegraph.com/subgraphs/name/beehive-innovation/rain-protocol-mainnet-e590ce",
        },
        blockExplorer: "https://etherscan.io",
        iconUrl: "../images/ethereum.svg",
        shortName: "ETH",
        DEFAULT_VERIFY: "0x2659fFEF960cf65780832330c13708aFc95F3Ad2",
        name: "Ethreum",
        RESERVE_TOKEN_ADDRESSES:[{
            name: "USDC",
            address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        }] 
    },
    137: {
        chainId: 137,
        chainName: "Polygon",
        nativeCurrency: { name: 'MATIC', symbol: 'MATIC', decimals: 18 },
        rpcUrls: ['https://polygon-rpc.com/'],
        subgraphs: {
            "v-0" : "https://api.thegraph.com/subgraphs/name/beehive-innovation/rain-protocol-v2-polygon",
            "v-1" : "https://api.thegraph.com/subgraphs/name/beehive-innovation/rain-protocol-polygon-e590ce"
        },
        blockExplorer: "https://polygonscan.com",
        iconUrl: "../images/polygon-icon.png",
        shortName: "POL",
        DEFAULT_VERIFY: "0xa1a36D3537bBe375Cc9694795F663DDC8D516Db9",
        name: "Polygon",
        RESERVE_TOKEN_ADDRESSES:[{
            name: "USDC",
            address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
        }] 
    },
    56: {
        chainId: 56,
        chainName: "Binance Smart Chain",
        nativeCurrency: { name: 'Binance Chain Native Token', symbol: 'BNB', decimals: 18 },
        rpcUrls: ['https://bsc-dataseed.binance.org/'],
        subgraphs: {
            "v-1" : "https://api.thegraph.com/subgraphs/name/beehive-innovation/rain-protocol-bnb-e590ce",
        },
        blockExplorer: "https://www.bscscan.com",
        iconUrl: "../images/binance.svg",
        shortName: "BSC",
        DEFAULT_VERIFY: "0xc1251Ed3138f204Fe687c05C8E7C3969cc7D6AC7",
        name: "Binance",
        RESERVE_TOKEN_ADDRESSES:[{
            name: "USDC",
            address: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
        }] 
    },
    5: {
        chainId: 5,
        chainName: "Etheruem Goerli",
        nativeCurrency: { name: 'Görli Ether', symbol: 'GOR', decimals: 18 },
        rpcUrls: ['https://goerli.infura.io/v3/${INFURA_API_KEY}'],
        subgraphs: {
            "v-1" : "https://api.thegraph.com/subgraphs/name/beehive-innovation/rain-protocol-goerli-e590ce",
        },
        blockExplorer: "https://goerli.etherscan.io",
        iconUrl: "../images/ethereum.svg",
        shortName: "ETH",
        DEFAULT_VERIFY: "0xBfF81fA3EB33f192C9431ca547BC4F5f86FB50cC",
        name: "Ethereum",
        RESERVE_TOKEN_ADDRESSES:[{
            name: "USDC",
            address: "0x41EcC69E54c5dfb2b5805736c733544e55673Aa0",
        }] 
    },
    80001: {
        chainId: 80001,
        chainName: "Polygon Mumbai",
        nativeCurrency: {
            name: "MATIC Token",
            symbol: "MATIC",
            decimals: 18,
        },
        rpcUrls: ["https://matic-mumbai.chainstacklabs.com/"],
        subgraphs: {
            "v-0": "https://api.thegraph.com/subgraphs/name/beehive-innovation/rain-protocol-v2_1-mumbai",
            "v-1" : "https://api.thegraph.com/subgraphs/name/beehive-innovation/rain-protocol-mumbai-e590ce"
        },
        blockExplorer: "https://mumbai.polygonscan.com",
        iconUrl: "../images/polygon-icon.png",
        shortName: "POL",
        DEFAULT_VERIFY: "0xEcFe7293B8814B624E834E02cfc3dDfe9A6d79b0",
        name: "Polygon",
        RESERVE_TOKEN_ADDRESSES:[{
            name: "USDC",
            address: "0x25a4Dd4cd97ED462EB5228de47822e636ec3E31A",
        }] 
    },
    97: {
        chainId: 97,
        chainName: "Binance Smart Chain Testnet",
        nativeCurrency: {
            name: 'Binance Chain Native Token',
            symbol: 'tBNB',
            decimals: 18
        },
        rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545"],
        subgraphs: {
            "v-1" : "https://api.thegraph.com/subgraphs/name/beehive-innovation/rain-protocol-bnb-chapel-e590ce",
        },
        blockExplorer: "https://testnet.bscscan.com",
        verifyTier: "",
        iconUrl: "../images/binance.svg",
        DEFAULT_VERIFY: "0x90882f1b52388aD8e41F9223638De510FBbE94CF",
        shortName: "BSC",
        name: "Binance",
        RESERVE_TOKEN_ADDRESSES:[{
            name: "PUSDC",
            address:"0xc360dd030F0A10D332313C98e32B12eFF564Ad34" // "0x64544969ed7EBf5f083679233325356EbE738930",
        }] 
    }
}
const NETWORKS = {};
for (let chainId of Object.values(NETWORK_CHAIN_IDS)) {
    NETWORKS[chainId] = SUPPORTED_NETWORKS[chainId];
}


export default NETWORKS;
